/**
 * Saved posts: a bookmark on discussions (the discussion page, beside Share; feed cards, in the theme's card
 * actions), and the Saved page (/saved), linked from the sidebar and from the member's own profile.
 * Other extensions use app.vouchaSaved: { isSaved(discussion), toggle(discussion) }.
 */
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import IndexPage from 'flarum/forum/components/IndexPage';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import GlobalSearchState from 'flarum/forum/states/GlobalSearchState';
const ROUTE = 'voucha-feed.saved';
const onSaved = () => app.current.get('routeName') === ROUTE;
function signUp() {
  const b = document.querySelector('.item-logIn .Button, .item-logIn button');
  if (b) b.click();
}
const isSaved = d => !!(d && d.attribute && d.attribute('vouchaSaved'));
function toggle(d) {
  if (!app.session.user) {
    signUp();
    return Promise.resolve(false);
  }
  const want = !isSaved(d);
  d.pushAttributes({
    vouchaSaved: want
  }); // show it straight away
  m.redraw();
  return app.request({
    method: 'POST',
    url: app.forum.attribute('apiUrl') + '/voucha-feed/saved/' + d.id(),
    body: {
      saved: want
    }
  }).then(() => {
    app.alerts.show({
      type: 'success'
    }, want ? 'Saved. Find it under Saved.' : 'Removed from Saved.');
    return want;
  }).catch(() => {
    d.pushAttributes({
      vouchaSaved: !want
    });
    m.redraw();
    return !want;
  });
}
export default function vouchaSaved() {
  app.vouchaSaved = {
    isSaved,
    toggle
  };
  app.routes[ROUTE] = {
    path: '/saved',
    component: IndexPage
  };

  // Sidebar: Saved, under Following (members)
  extend(IndexSidebar.prototype, 'navItems', function (items) {
    if (!app.session.user) return;
    items.add('vouchaSaved', m(LinkButton, {
      href: app.route(ROUTE),
      icon: "far fa-bookmark"
    }, "Saved"), 49);
  });
  extend(IndexPage.prototype, 'setTitle', function () {
    if (onSaved()) app.setTitle('Saved posts');
  });
  extend(GlobalSearchState.prototype, 'params', function (params) {
    params.onVouchaSaved = onSaved();
  });

  // The Saved page: the reader's saved discussions, most recently saved first
  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    if (this.params.onVouchaSaved) {
      params.filter = params.filter || {};
      params.filter.vouchaSaved = 1;
      delete params.sort;
    }
  });

  // Discussion page: Save beside Share
  extend('flarum/forum/components/DiscussionPage', 'sidebarItems', function (items) {
    const d = this.discussion;
    if (!d) return;
    const saved = isSaved(d);
    let priority = -40;
    try {
      if (items.has('share') && items.getPriority) priority = items.getPriority('share') - 1;
    } catch (e) {}
    items.add('vouchaSave', m(Button, {
      className: 'Button VouchaSaveButton' + (saved ? ' is-saved' : ''),
      icon: saved ? 'fas fa-bookmark' : 'far fa-bookmark',
      "aria-pressed": saved ? 'true' : 'false',
      onclick: () => toggle(d)
    }, saved ? 'Saved' : 'Save'), priority);
  });

  // Profile: Saved, on your own profile only
  extend('flarum/forum/components/UserPage', 'navItems', function (items) {
    const user = this.user;
    if (!user || !app.session.user || user !== app.session.user) return;
    items.add('vouchaSaved', m(LinkButton, {
      href: app.route(ROUTE),
      icon: "far fa-bookmark"
    }, "Saved"), 85);
  });
}